/* eslint-disable no-console */
/* eslint-disable func-style */
import _ from 'lodash';

/**
 * Identifies a user for a segment session.
 * See {@link https://segment.com/docs/connections/spec/identify/ segment documentation}.
 * @param {string} identifier - event identifier
 * @param {object} payload - event payload
 * @returns {void}
 */
export const identifyUser = (identifier, payload = {}) => {
  if (window.analytics && identifier) {
    window.analytics.identify(identifier, payload);
  }
};

/**
 * Tracks a participant event in segment.
 * See {@link https://segment.com/docs/connections/spec/track/ segment documentation}.
 * @param {string} identifier - event identifier
 * @param {object} payload - event payload
 * @param {string} userId - id of the current user
 * @returns {void}
 */
export const trackParticipant = (identifier, payload = {}, userId = false) => {
  try {
    const event = `Participant ${identifier}`;
    const options = {};

    if (userId) {
      options.integrations = {
        Slack: false,
        Mixpanel: userId,
      };
    }

    if (window.analytics) {
      window.analytics.track(event, payload, options);
    }
  } catch (e) {
    /* noop */
    // eslint-disable-line lines-around-comment
  }
};

export const track = (eventName, props) => {
    try {
      if (!eventName) {
        throw new Error('Tracking an event requires an event name');
      }

      if(window.analytics) {
        window.analytics.track(eventName, props);
      }
    } catch (error) {
      console.error('Segment::track', error);
    }
}

/**
 * Tracks a researcher event in segment.
 * @param {string} identifier - event identifier
 * @param {object} payload - event payload
 * @param {String} email
 */
export const trackResearcher = (identifier, payload, options, email = '') => {
  if (window.analytics) {
    try {
      const genericEmailPattern =
        /([a-zA-Z0-9._-]+@(gmail|msn|live|hotmail|yahoo|aol|outlook)+\.[a-zA-Z0-9._-]+)/gi;
      const opts = _.merge(
        {
          integrations: {
            Slack: false,
            Mixpanel: email ? !genericEmailPattern.test(email) : true,
          },
        },
        options
      );
      window.analytics.track(identifier, payload, opts);
    } catch (err) {
      console.log(err);
    }
  }
};
